import React from "react";
import { Bar } from "react-chartjs-2";
import { Grid, CircularProgress} from "@mui/material/";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import measureText from "./MeasureText";
import {
    Chart as ChartJS,
    BarElement,
    Tooltip,
    LinearScale,
    Title,
    Legend,
    CategoryScale,
  } from "chart.js";

  export default function HorizontalBarChart(props) {
    const fetchdata = (sessionStorage.getItem('getHorizontalBarData') !== null) ? JSON.parse(sessionStorage.getItem('getHorizontalBarData')) : undefined;
    var CountryName = (props.Country !== 'none') ? props.Country : 'Total'
    let barSizes = [];
    const data = fetchdata !== undefined ? barData(fetchdata) : null;
    function barData(rawData) {
        var info_Bar = [];
        var Labels = [];
        var Bar_colour = [];
        var total = 0
        var light_gray = "#B8B8B8"
        var total_colour = "#2E79B1"
        var Bar_Charts = [];
        let CountryChoice = CountryName;
        let borrowTotalData;
        let borrowEUData;
        let done = false;

        for (let i=0;i<rawData.length;i++){
          let countryDeter = rawData[i].Country;
          if (countryDeter === CountryName){
            CountryChoice = countryDeter;
            done = true;
          }
          else if (CountryName !== 'Total' && countryDeter !== CountryName && done === false){
            CountryChoice = 'European Union'
          }
          if (countryDeter === 'Total'){
            borrowTotalData = rawData[i].TotalData;
          }
          if (countryDeter === 'European Union'){
            borrowEUData = rawData[i].TotalData;
          }
        }

        // loop through countries to find the country clicked.
        for(var i = 0; i < rawData.length; i++){
          var Country = rawData[i].Country;
          if (Country === CountryChoice) {
            var xCountry = rawData[i].TotalData;
           // loop through categories to create bar charts
           for(var y = 0; y < xCountry.length; y++) {
            var xCategory = xCountry[y].data;
            var catName = xCountry[y].category;
            //loop through the sub categories of the categories and push them + the numbers to bar chart
              for(var n = 0; n < borrowTotalData[y].data.length; n++) {
                // Just use the name of the total data to keep the diagrams as steady as possible
                let subCatNameTotal = borrowTotalData[y].data[n].subCategory
                let paddedSubCatNameTotal = subCatNameTotal
                

                // 
                while (measureText(paddedSubCatNameTotal) < 190) {
                  paddedSubCatNameTotal = (paddedSubCatNameTotal + " ");
                }
                Labels.push(paddedSubCatNameTotal);

                let EUNumber = 0;

                let subCatName;
                let subCatNum;

                // Look if the specific country holds data for this specific subcategory
                for (let a = 0; a<xCategory.length; a++){
                  if (xCategory[a].subCategory === subCatNameTotal){
                    subCatName = xCategory[a].subCategory;
                    subCatNum = xCategory[a].NUM;
                    break;
                  }
                }
                // Look if the EU holds data for this specific subcategory
                for (let a=0; a<borrowEUData[y].data.length;a++){
                  if (borrowEUData[y].data[a].subCategory === subCatNameTotal){
                    EUNumber = borrowEUData[y].data[a].NUM;
                  }
                }

                let infoBarNum = 0;
                // To add the country specific numbers
                if (subCatNameTotal === subCatName && Country !== 'European Union' && Country !== 'Total'){
                  infoBarNum = parseInt(subCatNum);
                  total = parseInt(total) + parseInt(infoBarNum);
                  
                }
                // To add the EU numbers
                if (Country !== 'Total'){
                  
                  infoBarNum = parseInt(infoBarNum) + parseInt(EUNumber);
                 
                  total = total + parseInt(EUNumber)
                }
                // If no country is selected
                if (Country === 'Total'){

                  infoBarNum = parseInt(subCatNum)
                  total = parseInt(total) + parseInt(infoBarNum)
                }
                // If infoBarNum is 0, give it no value to the bar to prevent ugly '0'
                infoBarNum = infoBarNum === 0 ? "" : infoBarNum;

                // Push the data to the desired Array
                info_Bar.push(infoBarNum);
                Bar_colour.push(light_gray);
              }

              // If total is 0, give it no value to the bar to prevent ugly '0'
              total = total === 0 ? "" : total;
              
              Labels.push("Total " + catName);
              info_Bar.push(total);
              Bar_colour.push(total_colour)
              barSizes.push(total)

              // Create barchart of the category and put them in an array of other bar charts
              let Bar_Chart = {
                labels: Labels,
                datasets: [
                  {
                    label: catName,
                    data: info_Bar,
                    backgroundColor: Bar_colour,
                    barPercentage: 0.5,
                    barThickness: 12,
                    maxBarThickness: 14,
        
                  },
                ],
              };
              Bar_Charts.push(Bar_Chart)
              Labels = [];
              info_Bar = [];
              Bar_colour= [];
              total = 0;

           }
         }
       }
       
              return Bar_Charts;    

    }
    
    const options = {
        indexAxis: 'y',
        animation: {
          duration: 0,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            grid: {
              display: false
            },
          
            ticks: {
              crossAlign: "far",
              padding: 2,
              font: {
                family:'Helvetica'
              },
            },
          },
          x: {
            grid: {
              display: false
            },
            min: 0,
            max: Math.max(...barSizes) * 1.1,
            ticks: {
              display: false
            },
          },
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'right',
            labels: {
              title: {
                font: {
                  weight: 'bold',
                }
              }
            }
          },
          legend: {
            align: 'start',
            title: {
              position: 'start'
            },

            labels: {
              boxWidth: 0,
              font: {
                weight: "bolder",
              },
            },
          },
        },
      };
    
      ChartJS.register(
        BarElement,
        Tooltip,
        CategoryScale,
        LinearScale,
        Title,
        Legend,
        ChartDataLabels
      );

      // When the requested data returned, return a BarChart
    if (fetchdata !== undefined && fetchdata !== "") {      
    return ( 
      <Grid container spacing={2} padding={1}>
        <Grid  item xs={2}>
        </Grid>
        <Grid item xs={9}>
          <Bar data={data[0]} options={options} width="100px"/>
        </Grid>
        <Grid  item xs={2}>
        </Grid>
        <Grid item xs={9}>
          <Bar data={data[1]} options={options} width="100px"/>
        </Grid>
        <Grid  item xs={2}>
        </Grid>
        <Grid item xs={9}>
          <Bar data={data[2]} options={options} width="100px"/>
        </Grid>
        <Grid  item xs={2}>
        </Grid>
        <Grid item xs={9}>
          <Bar data={data[3]} options={options} width="100px"/>
        </Grid>
        <Grid  item xs={2}>
        </Grid>
        <Grid item xs={9}>
          <Bar data={data[4]} options={options} width="100px"/>
        </Grid>
      </Grid>
    );
      }
    else {
        return <CircularProgress />
    }
}

